<script type="text/javascript">
	import { onMount, onDestroy } from "svelte";
	import { get, writable } from "svelte/store";

	import Sortable from "sortablejs/modular/sortable.core.esm.js";

	import Textfield, {Input, Textarea} from "@smui/textfield";
	import TextfieldWithButton from "../TextfieldWithButton/TextfieldWithButton.svelte";

	import StringHelper from "../../Helpers/StringHelper";
	import GeoHelper from "../../Helpers/GeoHelper";

	import arrayMove from "../../Helpers/Misc/arrayMove";
	import roundFloat from "../../Helpers/Misc/roundFloat";

	import RangeRingView from "./RangeRing/View.svelte";

	import MapStore from "../../Map/Store";
	import RoutePlottingStore from "./RoutePlottingStore";

	export let routePlot = null;
	export let index = 0;

	let points = routePlot.points;
	let journeys = routePlot.journeys;
	let timeErr = routePlot.results.errs.time;
	let lastUpdated = routePlot.lastUpdated;

	let resultDistanceNm = routePlot.results.distance.nauticalMiles;
	let resultDistanceKm = routePlot.results.distance.km;
	let resultTime = routePlot.results.time;

	$: if ($points.length > 0) {
		for(let i = 0; i < $points.length; i++) {
			let point = $points[i];

			for(let j = 0; j < point.rangeRings.length; j++) {
				point.rangeRings[j].input.lng.set(point.position.lng);
				point.rangeRings[j].input.lat.set(point.position.lat);
			}
		}
	}

	let updatePoint = (index, lngLatStr) => {
		if (!GeoHelper.isValidLngLat(lngLatStr)) {
			return;
		}
		$points[index].positionStr = lngLatStr;
		const parsedLngLat = GeoHelper.parseStringLngLat(lngLatStr);
		$points[index].position.lng = parsedLngLat[0];
		$points[index].position.lat = parsedLngLat[1];

		// point.positionStr
		$points = [...$points];

		$lastUpdated = Date.now();
	};

	let sortableLi;
	let sortable;
	onMount(()=>{
		sortable = new Sortable(sortableLi, {
			sort: true,
			draggable: ".draggable",
			handle: ".handle",
			onEnd: (evt) => {
				arrayMove($points, evt.oldIndex, evt.newIndex);
				// arrayMove($journeys, evt.oldIndex, evt.newIndex); // we don't want to move the journeys
				$points = [...$points];
				$journeys = [...$journeys];
				// routePlot = routePlot;
				$lastUpdated = Date.now();
			}
		});
	});

	let speedAll = writable(1);
	let setAllJourneys = (speedVal) => {
		if (Number.isNaN(parseFloat(speedVal))) {
			return;
		}
		let val = parseFloat(speedVal);
		for (let i = 0; i < $journeys.length; i++) {
			$journeys[i].speedKnots = val;
		}
		$points = $points;
		$journeys = $journeys;
		$lastUpdated = Date.now();
		// console.log($journeys);
	};

	$: {
		$lastUpdated;
		if (routePlot !== null) {
			routePlot.recalculateDistance();
			RoutePlottingStore.helpers.rebuildGeoJSON();
			// routePlot = routePlot;
		}
	}

</script>


<style >
	.routeplot-container {
		padding:10px;
		padding-top:3px;
		padding-bottom:3px;
		border-radius:5px;
		background-color:#f0f0f0;
		margin-bottom:6px;
	}
	.routeplot-item {
		background-color:white;
		border-radius:5px;
		margin-bottom:5px;
		overflow: auto;
	}
	.routeplot-item-handle {
		width:20px;
		padding:10px;
		float:left;
	}
	.routeplot-item-handle .handle {
		cursor:pointer;
	}
	.routeplot-item-content  {
		padding:10px;
		float:left;
		width:calc(100% - 20px - 20px - 20px);
	}
	.routeplot-item-content.fullwidth { 
		width: calc(100% - 20px);
	}
	.routeplot-container .btn-sml {
		display: inline-block;
		font-size: 12px;
		float: right;
		margin-left: 4px;
		margin-top: 4px;
		cursor:pointer;
	}
	.routeplot-container p.section-title {
		margin-top:5px;
		margin-bottom:10px;
	}
	.routeplot-container p.section-distance {
		margin-bottom:5px;
	}

</style>

<div class='routeplot-container'>
	<p><b>Route #{index+1}</b></p>
	{#if $points.length === 0}
		<p>Add a point to get started...</p>
	{/if}

	<div bind:this={sortableLi} class="oa" role="list">
		{#each $points as point, index (point)}
			<div class='draggable'>
				<div class='routeplot-item oa'>
					<div class='routeplot-item-handle'>
						<p style='margin-top:1px;margin-left:2px;'><span class='material-icons handle'>drag_indicator</span></p>
					</div>
					<div class='routeplot-item-content'>

						<p class='section-title'><b>Point</b></p>
						<!-- <Textfield dense variant="filled" label="Lng,lat" value={point.positionStr} /> -->
						<TextfieldWithButton
							value={point.positionStr}
							dense
							variant="filled"
							buttonIcon="colorize"
							label="Lng,lat"
							on:change={(e)=>{
								updatePoint(index, e.target.value);
							}}
							on:keyup={(e) => {
								updatePoint(index, e.target.value);
							}}
							on:buttonclick={(e) => {
								MapStore.helpers.startSingleLngLatPick((resultText)=>{
									updatePoint(index, resultText);
								});
							}}
							style="width:100%"
							/>

						{#if point.rangeRings.length > 0}
							<!-- <p><b>Range Rings</b></p> -->
							<div style="background-color:white; border-radius:5px; padding:1px;padding-left:10px;padding-right:10px;">
								{#each point.rangeRings as rangeRing, index (rangeRing)}
									<RangeRingView data={rangeRing} paddingBottom={false} on:change={()=>{
										console.log('ring changed');
										$lastUpdated = Date.now();
									}}/>
								{/each}
							</div>
						{/if}

						<div class='oa' class:mt-10={point.rangeRings.length>0} style='margin-bottom:3px;'>
							{#if point.rangeRings.length > 0}
								<button class='btn btn-sml bg-warning' on:click={()=>{point.removeAllRangeRings(); $lastUpdated = Date.now(); }}>Clear Rings</button>
							{/if}

							<button class='btn btn-sml bg-info' on:click={()=>{point.addRangeRing(); $lastUpdated = Date.now(); }}>Add Range Ring</button>
						</div>

						{#if point.waitEnabled}
							<div class='oa' style='margin-top:5px;'>
								<!-- <Textfield dense variant="filled" label="Wait (Hours)" style="width:100%" bind:value={point.waitHours} on:keyup={(e)=>{
								$lastUpdated = Date.now();
								}}/>
								<button class='btn btn-sml bg-info' on:click={()=>{ point.waitEnabled = false; $lastUpdated = Date.now(); }}>Remove Wait</button> -->
								<TextfieldWithButton
									value={point.waitHours}
									dense
									variant="filled"
									buttonIcon="clear"
									label="Wait (Hours)"
									on:keyup={(e) => {
										point.waitHours = e.target.value;
										$lastUpdated = Date.now();
									}}
									on:buttonclick={(e) => {
										point.waitEnabled = false;
										$lastUpdated = Date.now();
									}}
									style="width:100%"
									/>
							</div>
						{:else}
							<div class='oa'>
								<p class='fl' ><b>No Wait</b></p>
								<!-- style='margin-bottom:0px;' -->
								<button class='btn btn-sml bg-info fr' style="margin-top:12px;" on:click={()=>{ point.waitEnabled = true; $lastUpdated = Date.now(); }}>Add Wait</button>
							</div>
						{/if}


						<button class='btn btn-sml bg-error' on:click={(e)=>{
							console.log('e', e);
							console.log(point, index);
							routePlot.removePointByIndex(index);
						}}>Remove Point</button>


					</div>
				</div>

				{#if index !== $points.length-1}
					<div class='routeplot-item oa'>
						<div class='routeplot-item-handle'></div>
						<div class='routeplot-item-content'>
							<p class='section-title'><b>Journey</b></p>
							<!-- {#if $journeys[index].by === "speed"} -->
								<Textfield dense variant="filled" label="Speed (knots)" style="width:100%" bind:value={$journeys[index].speedKnots} on:keyup={()=>{
									$lastUpdated = Date.now();
								}}/>
							<!-- {:else} -->
								<!-- <Textfield dense variant="filled" label="Time (hours)" style="width:100%" value={$journeys[index].timeHours} /> -->
							<!-- {/if} -->
							<p class='section-distance'><b>Distance:</b> {roundFloat(get($journeys[index].distance.nauticalMiles),2)} nm / {roundFloat(get($journeys[index].distance.km),2)} km</p>
						</div>
					</div>
				{/if}
			</div>
		{/each}
	</div>

	<div class='oa mb-5'>
		{#if $points.length > 0}
			<button class='btn btn-sml bg-error' on:click={()=>{routePlot.clearAllPoints()}}>Clear All</button>
		{/if}
		<button class='btn btn-sml bg-success' on:click={()=>{routePlot.addPoint()}}>Add Point</button>
	</div>

	{#if $points.length > 2}
		<div class='routeplot-item oa mb-5'>
			<div class='routeplot-item-content fullwidth'>
				<p class='section-title'><b>Set All Journey Speeds</b></p>
				<Textfield dense variant="filled" label="Speed (knots)" style="width:100%" bind:value={$speedAll} />
				<button class='btn btn-sml bg-secondary btn-block' on:click={()=>{ setAllJourneys($speedAll); }}>Set</button>
			</div>
		</div>

	{/if}

	{#if $points.length > 1}
		<p><b>Total Journey Time:</b> {StringHelper.formatHoursAndMinutes($resultTime)}</p>
		<p><b>Total Distance:</b> {roundFloat($resultDistanceNm,2)} nm / {roundFloat($resultDistanceKm,3)} km {#if $resultDistanceKm < 1}({parseInt($resultDistanceKm * 1000)} metres){/if}</p>
	{/if}
	{#if $timeErr.length > 0}
		<p class="err"><b>Error: {$timeErr}</b></p>
	{/if}

	<p style='display:none;'>{$lastUpdated}</p>

</div>
